export enum ETestIds {
  PresentationImg = 'presentationImg',
  PresentationBtn = 'presentationBtn',
  OfferCard = 'offerCard',
  OfferCardBtn = 'offerCardBtn',
  PersonalizedOffer = 'personalizedOffer',
  MortgageOfferValidation = 'mortgageOfferValidation',
  MortgageOfferValidationMessage = 'mortgageOfferValidationMessage',
}
